module.exports = __webpack_public_path__ + "static/img/taiPing.e0431629.png";